var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-navigation-drawer",
        {
          staticStyle: { "background-color": "#fafafa" },
          attrs: {
            width: "85%",
            temporary: "",
            right: "",
            app: "",
            id: "sidebar",
            touchless: _vm.loggedOut
          },
          on: {
            input: function($event) {
              return _vm.capture($event)
            }
          },
          model: {
            value: _vm.menudrawer,
            callback: function($$v) {
              _vm.menudrawer = $$v
            },
            expression: "menudrawer"
          }
        },
        [
          _c("Sidebar", {
            key: "sidebar" + _vm.refresh,
            attrs: {
              userData: _vm.userData,
              userId: _vm.userId,
              owner: _vm.owner,
              storeData: _vm.storeData,
              subscriptions: _vm.subscriptions,
              selectedLocation: _vm.selectedLocation,
              app: ""
            },
            on: {
              "refresh-merchant-profile": function($event) {
                return _vm.GetOwnerProfile()
              },
              "refresh-location-details": function($event) {
                return _vm.Refresh("sidebar")
              },
              relogin: function($event) {
                return _vm.ToRelogin($event)
              },
              logout: function($event) {
                return _vm.logout($event)
              }
            }
          })
        ],
        1
      ),
      _c(
        "v-app-bar",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loggedOut,
              expression: "!loggedOut"
            }
          ],
          staticStyle: { margin: "0 auto" },
          attrs: {
            flat: "",
            color: "white",
            fixed: "",
            app: "",
            width: "640px"
          }
        },
        [
          _c("v-spacer"),
          _c(
            "v-toolbar-title",
            [
              _c("v-img", {
                staticStyle: { "margin-left": "80px" },
                attrs: {
                  "max-height": "40",
                  "max-width": "100",
                  src: require("img/wiom_logo.png")
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _vm.selectedLocation && _vm.selectedLocation.nasid
            ? _c("Notifications", {
                key: "notifications::" + _vm.selectedLocation.nasid,
                attrs: {
                  userData: _vm.userData,
                  selectedLocation: _vm.selectedLocation
                }
              })
            : _vm._e(),
          _c("v-app-bar-nav-icon", {
            attrs: { color: "black" },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.toggleMenu()
              }
            }
          })
        ],
        1
      ),
      _c(
        "v-content",
        { attrs: { id: _vm.loggedOut } },
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", "max-width": "90%" },
                  model: {
                    value: _vm.showTroubleShooting,
                    callback: function($$v) {
                      _vm.showTroubleShooting = $$v
                    },
                    expression: "showTroubleShooting"
                  }
                },
                [
                  _c("Troubleshoot", {
                    on: {
                      cancel: function($event) {
                        _vm.showTroubleShooting = false
                      }
                    }
                  })
                ],
                1
              ),
              !_vm.loggedOut
                ? _c("Dashboard", {
                    key:
                      _vm.userId +
                      "::" +
                      _vm.selectedSection +
                      "::" +
                      _vm.refresh,
                    attrs: {
                      userId: _vm.userId,
                      userData: _vm.userData,
                      selectedSection: _vm.selectedSection,
                      showNotifications: _vm.showNotifications,
                      selectSection: _vm.selectSection,
                      selectTab: _vm.selectTab,
                      selectNasid: _vm.selectNasid
                    },
                    on: {
                      "get-owner-details": function($event) {
                        return _vm.setOwnerDetails($event)
                      },
                      "get-locations": function($event) {
                        return _vm.setLocations($event)
                      },
                      "location-selected": function($event) {
                        return _vm.locationSet($event)
                      },
                      "update-loc-details": function($event) {
                        return _vm.UpdateLocation()
                      },
                      "update-merch-details": function($event) {
                        return _vm.UpdateMerchant()
                      },
                      "got-inactive-locations": function($event) {
                        _vm.inactiveLocationsCount = $event
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-footer",
        {
          style: { margin: "0 auto", "max-width": "640px" },
          attrs: { id: _vm.loggedOut, app: "" }
        },
        [
          !_vm.loggedOut
            ? _c(
                "v-bottom-navigation",
                {
                  style: { background: "#f3f3f3" },
                  attrs: {
                    absolute: "",
                    grow: "",
                    color: "white",
                    fixed: true
                  },
                  model: {
                    value: _vm.section,
                    callback: function($$v) {
                      _vm.section = $$v
                    },
                    expression: "section"
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        id: "manageBtn",
                        value: "manage",
                        "max-width": "100%"
                      },
                      on: {
                        click: function($event) {
                          return _vm.setSelectedSection("manage")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "fs-12 fw-700" }, [
                        _vm._v("Your Wi-Fi")
                      ]),
                      _c("b", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("Manage")
                      ])
                    ]
                  ),
                  _c("v-divider", { attrs: { vertical: "" } }),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        id: "valueBtn",
                        value: "values",
                        "max-width": "100%"
                      },
                      on: {
                        click: function($event) {
                          return _vm.setSelectedSection("value")
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "fs-12 fw-700" }, [
                        _vm._v("Your Business")
                      ]),
                      _c("b", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("Grow")
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }